import { useMemo } from "react";
import { ObjectSchema, Schema } from "yup";

import {
  IProductionRecurringTime,
  TTimeHHmm,
  yupLocalized,
} from "@ryde/shared";

export const useTimeListItemResolver = () => {
  const timeItemFormValidationSchema: ObjectSchema<
    Partial<IProductionRecurringTime>
  > = useMemo(() => {
    return yupLocalized.object<Partial<IProductionRecurringTime>>().shape({
      time: yupLocalized.string().required() as Schema<TTimeHHmm>,
    });
  }, []);

  return { timeItemFormValidationSchema };
};
